import React, { Component } from 'react'
import intl from 'react-intl-universal'
import object_value from '../api/object_value'
import moment from 'moment'
import 'moment-timezone'

class ExperienceUser extends Component {
  render () {
    console.log('ExperienceUser.js - render() - this.props', this.props)
    const { variant, experience_user } = this.props
    console.log('ExperienceUser.js - render() - experience_user', experience_user)

    if (!experience_user) {
      return (<div />)
    }

    let surname = experience_user.surname ? experience_user.surname.charAt(0) + '.' : ''
    let name = experience_user.prename + ' ' + surname

    let image_url = experience_user.image_url
    let image_style = image_url
      ? { backgroundImage: 'url(' + image_url + ')' }
      : {}

    let since_date = moment(experience_user.created_at).utc()/*.tz('Europe/Berlin')*/.format('YYYY')

    let {description} = experience_user

    let user = {
      name,
      image_style,
      since_date,
      description
    }
    
    if (variant === 'details') {
      return (
        <div className='b-event-details-author'>
          <a href={'/user/' + experience_user.id}
             className='b-event-details-author-picture'
             style={user.image_style} />
          <a href={'/user/' + experience_user.id}
             className='b-event-details-author-name'>{user.name}</a>
          <div className='b-event-details-author-about'>{intl.get('experiences.member_since')} {user.since_date}</div>
        </div>
      )
    }
    
    if (variant === 'full') {
      return (
        <div className='b-event-details-blocks'>
          <div className='b-event-details-block'>
            <div className='b-event-details-block-label'>{intl.get('experiences.author_label')}</div>
            <div className='b-event-details-block-value'>
              <div className='b-event-details-author'>
                <a href={'/user/' + experience_user.id}
                   className='b-event-details-author-picture'
                   style={user.image_style} />
                <a href={'/user/' + experience_user.id}
                   className='b-event-details-author-name'>{user.name}</a>
                <div className='b-event-details-author-about'>{intl.get('experiences.member_since')} {user.since_date}</div>
              </div>
              {user.description &&
              <p className='lead'>
                {user.description}
              </p>}
              {/*<p className='not-working'>
                Quisque placerat facilisis egestas cillum dolore. Pellentesque habitant morbi tristique senectus et
                netus. Morbi fringilla convallis sapien, id pulvinar odio volutpat. Mercedem aut nummos unde unde
                extrica.
              </p>*/}
            </div>
          </div>
        </div>
      )
    }
  }
}

export default ExperienceUser



// WEBPACK FOOTER //
// ./src/components/ExperienceUser.js